import React from "react";
import { Check } from "lucide-react";

const why = [
  "Scalable & maintainable architecture",
  "Transparent communication & timelines",
  "Dedicated 5-member delivery team",
  "Security-first development practices",
  "End-to-end support (Dev + Hosting + Domain)",
  "Quality-focused delivery & testing",
];

const techChips = [".NET Core", "Angular", "React", "React Native", "SQL Server", "PostgreSQL", "Firebase"];

export const About = () => {
  return (
    <section id="about" className="relative bg-[#05070f] py-24 overflow-hidden">
      <div className="absolute top-1/4 right-0 w-[420px] h-[420px] rounded-full bg-violet-700/10 blur-[130px]" />
      <div className="relative max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="reveal relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-blue-600/25 to-violet-600/20 blur-2xl rounded-[2rem]" />
            <div className="relative rounded-[2rem] overflow-hidden glass-strong p-2">
              <img
                src="img/about/aboutus.png"
                alt="About Sudeeshaa Solutions"
                className="w-full rounded-[1.5rem] object-cover"
              />
            </div>
            {/* floating badge */}
            <div className="absolute -bottom-5 -right-3 sm:right-6 rounded-2xl glass-strong px-5 py-4 shadow-xl float">
              <div className="font-display text-2xl text-white">5+</div>
              <div className="text-xs text-slate-400 font-semibold">Years Combined Exp.</div>
            </div>
          </div>

          {/* Copy */}
          <div>
            <span className="eyebrow reveal">Who We Are</span>
            <h2 className="reveal d1 mt-5 font-display text-white text-3xl md:text-5xl">
              A focused team that <span className="text-gradient">ships</span>
            </h2>
            <p className="reveal d2 mt-5 text-slate-400 leading-relaxed">
              Sudeeshaa Solutions is an India-based software development company focused
              on building secure, scalable and high-performance digital products. Our
              5-member team delivers web applications, mobile apps, backend APIs,
              database solutions and deployment support for startups and businesses.
            </p>

            <div className="reveal d3 mt-7 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              {why.map((d) => (
                <div key={d} className="flex items-start gap-2.5">
                  <span className="mt-0.5 h-5 w-5 shrink-0 rounded-full bg-gradient-to-br from-blue-600 to-violet-600 grid place-items-center">
                    <Check className="h-3 w-3 text-white" strokeWidth={3} />
                  </span>
                  <span className="text-slate-300 text-sm">{d}</span>
                </div>
              ))}
            </div>

            <div className="reveal d4 mt-8 flex flex-wrap gap-2">
              {techChips.map((t) => (
                <span key={t} className="text-xs font-bold text-slate-300 px-3 py-1.5 rounded-full glass">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
